export interface DateRange {
  from: string
  to: string
}

export interface FilterChip {
  key: string
  label: string
  onRemove: () => void
}

export const FROM_PARAM = 'from'
export const TO_PARAM = 'to'
export const PERIOD_LABEL = 'Period'
export const PERIOD_CHIP_KEY = 'period'
export const EMPTY_DATE_RANGE: DateRange = { from: '', to: '' }

const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/

// Backend avvisar ogiltiga datum med 400 – en handredigerad URL ska inte kunna låsa hela listan.
function parseDate(value: string | null): string {
  if (value !== null && ISO_DATE_PATTERN.test(value)) {
    return value
  }

  return ''
}

export function parseDateRange(params: URLSearchParams): DateRange {
  return { from: parseDate(params.get(FROM_PARAM)), to: parseDate(params.get(TO_PARAM)) }
}

// Skriver om perioden från grunden så att ett rensat datum inte ligger kvar i URL:en.
export function writeDateRange(params: URLSearchParams, range: DateRange): void {
  params.delete(FROM_PARAM)
  params.delete(TO_PARAM)

  if (range.from !== '') {
    params.set(FROM_PARAM, range.from)
  }

  if (range.to !== '') {
    params.set(TO_PARAM, range.to)
  }
}

export function hasDateRange(range: DateRange): boolean {
  return range.from !== '' || range.to !== ''
}

function formatDateRange(range: DateRange): string {
  if (range.from !== '' && range.to !== '') {
    return `${range.from} – ${range.to}`
  }

  if (range.from !== '') {
    return `från ${range.from}`
  }

  return `till ${range.to}`
}

export function getPeriodChipLabel(range: DateRange): string {
  return `${PERIOD_LABEL}: ${formatDateRange(range)}`
}
